import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const CreateAccountWrapper = styled.div`
  display: flex;
  flex-direction: column;
  & > label {
    margin: 10px 0;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 23px;
  }
  & > [data-type='text'],
  & > [data-type='date'],
  & > [data-type='password'] {
    & label {
      display: inline !important;
      width: auto;
      margin-left: 10px;
      border: none;
    }
  }

  input[type='text'],
  input[type='date'],
  input[type='password'] {
    padding-top: 10px;
    & + span {
      display: flex !important;
      border: unset;
      position: absolute;
      width: 100%;
      left: 20px;
      top: 3px;
      //font-size: 10px;
      line-height: 14px;
      color: #94e6fb;
    }

    &[data-invalid='invalid'] + span,
    &[data-invalid='none'] + span,
    &[data-invalid='true'] + span {
      color: #ff4c4c !important;
    }
    ::-webkit-input-placeholder,
    textarea:focus::-webkit-input-placeholder {
      /* WebKit browsers */
      color: transparent;
    }
    :-moz-placeholder,
    textarea:focus:-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      color: transparent;
    }
    ::-moz-placeholder,
    textarea:focus::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      color: transparent;
    }
    :-ms-input-placeholder,
    textarea:focus:-ms-input-placeholder {
      /* Internet Explorer 10+ */
      color: transparent;
    }
  }
  & > .tit-user {
    margin-top: 30px;
  }
`;
export const UserInfoSection = styled.section`
  display: grid;
  & > [data-type='text'],
  & > [data-type='date'],
  & > [data-type='password'] {
    & label {
      display: inline !important;
      width: auto;
      margin-left: 10px;
      border: none;
    }
  }

  grid-gap: 20px;
  grid-template:
    'id id'
    'fname lname'
    'pwd pwd';
`;
const CloseButtonStyle = css`
  width: 218px;
  height: 48px;
  border-color: #999999;
  color: #999999;
  :hover {
    background-color: rgba(153, 153, 153, 0.2);
  }
  :active {
    background: #999999;
  }
`;
export const CreateButtonStyle = css`
  margin-left: 10px;
  width: 218px;
  height: 48px;
`;

export const CommonValidationStyle = css`
  input[data-invalid$='true' i]:invalid,
  input[data-invalid='same-with-id' i],
  input[data-invalid='validate-mix' i],
  input[data-invalid='short' i],
  input[data-invalid='invalid'] {
    border-color: #ff4c4c !important;
    position: relative;
    & ~ span {
      color: #ff4c4c;
    }
    & ~ div[data-type='validate'] {
      display: block !important;
      width: 100%;
      &::after {
        color: #ff4c4c;
        font-size: 13px;
        text-align: left;
        position: absolute;
        left: 0;
        top: 100%;
        width: 100%;
      }
    }
  }
`;
export const PwValidationStyle = css`
 
  input {
     & ~ div[data-type='validate'] {
       &::after {
        position: absolute;
        left: 0;
        top: 100%;
        width: 100%;
        font-size: 13px;
        text-align: left;
       }
     }
   }
  input[data-invalid$='true' i]:invalid {
     & ~ div[data-type='validate'] {
       &::after {
         color:#ff4c4c;
         content: 'Please enter the Password.';
       }
     }
   }
   input[data-invalid='same-with-id' i] {
     & ~ div[data-type='validate'] {
     color:red;
       &::after {
         color:#ff4c4c;
         content: 'It cannot be the same as the ID.';
       }
     }
   }
   input[data-invalid='same-with-email' i] {
     & ~ div[data-type='validate'] {
     color:red;
       &::after {
         color:#ff4c4c;
         content: 'It cannot be the same as the ID.';
       }
     }
   }
   input[data-invalid='short' i] {
     & ~ div[data-type='validate'] {
       &::after {
         color:#ff4c4c;
         content: 'Use at least 10 characters. (letters, numbers and symbols other than \<\>\\'\&\\"\(\)\#)';
       }
     }
   }
   input[data-invalid='regrex' i] {
     color:red;
     & ~ div[data-type='validate'] {
       &::after {
       color:#ff4c4c;
        content: 'Use at least 10 characters. (letters, numbers and symbols other than \<\>\\'\&\\"\(\)\#)';
      }
    }
  }
   
`;

export const NameValidationStyle = css`
  input[data-invalid$='invalid' i] {
    & ~ div[data-type='validate'] {
      &::after {
        content: 'Please enter a valid name.';
      }
    }
  }
`;

export const EmailValidationStyle = css`
  input[data-invalid='invalid' i] {
    & ~ div[data-type='validate'] {
      &::after {
        content: 'Please enter a valid Email.';
        color: #ff4c4c;
      }
    }
  }

  input[data-invalid='regex-invalid' i] {
    & ~ div[data-type='validate'] {
      &::after {
        content: 'Use only Email address.';
        color: #ff4c4c;
        font-size: 13px;
        position: absolute;
        top: 100%;
        height: 30px;
      }
    }
  }
`;
